import { useContext } from 'react'
import {
  DragAndDropContext,
  IDragAndDropContext,
} from '@providers/dragAndDropProvider'

export default function useDragAndDrop(): IDragAndDropContext {
  return useContext(DragAndDropContext)
}
